import {ExtraOptions} from '@angular/router';
import {environment} from '~env/environment';

export const singleSpaRoutingOptions = (): ExtraOptions => {
    const options: ExtraOptions = {};

    if (typeof(environment.useHash) === 'boolean') {
        options.useHash = environment.useHash;
    }

    return options;
};
